import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import BlogCard from './components/BlogCard';
import {
  BlogPage,
  BlogContainer,
  BlogHeader,
  BlogPreTitle,
  BlogTitle,
  BlogSubtitle,
  CategoriaRow,
  CategoriaPill,
  HeroPost,
  HeroImageWrap,
  HeroImage,
  HeroContent,
  HeroPostTitle,
  HeroPostExcerpt,
  PostCardMeta,
  PostGrid,
  EmptyState,
  LoadingWrap,
} from './styles/BlogStyles';
import {
  getPublishedPosts,
  getAllCategorias,
  getBlogImageUrl,
  getCategoriaLabel,
  formatPostDate,
  estimateReadingTime,
} from '../services/blogService';
import { MF_BASE } from '../basePath';

export default function BlogIndexPage() {
  const navigate = useNavigate();
  const [posts, setPosts] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = 'Blog | MF Real Estate — Mercado imobiliário em Alphaville';
    const meta =
      document.querySelector('meta[name="description"]') ||
      (() => {
        const m = document.createElement('meta');
        m.name = 'description';
        document.head.appendChild(m);
        return m;
      })();
    meta.content =
      'Análises, guias de condomínios e tendências do mercado imobiliário de Alphaville (Barueri/SP) pela equipe MF Real Estate.';
  }, []);

  useEffect(() => {
    let active = true;
    (async () => {
      setLoading(true);
      const [postsData, catsData] = await Promise.all([
        getPublishedPosts({ limit: 30 }),
        getAllCategorias(),
      ]);
      if (!active) return;
      setPosts(postsData);
      setCategorias(catsData);
      setLoading(false);
    })();
    return () => {
      active = false;
    };
  }, []);

  const featured = posts[0];
  const rest = posts.slice(1);

  const goToPost = (slug) => navigate(`${MF_BASE}/blog/${slug}`);
  const goToCategoria = (slug) =>
    navigate(`${MF_BASE}/blog/categoria/${slug}`);

  return (
    <BlogPage>
      <Navbar />

      <BlogContainer>
        <BlogHeader>
          <BlogPreTitle>Blog MF Real Estate</BlogPreTitle>
          <BlogTitle>Mercado imobiliário em Alphaville</BlogTitle>
          <BlogSubtitle>
            Análises, guias de condomínios e perspectivas reais de quem atende
            Alphaville e região todos os dias.
          </BlogSubtitle>

          {categorias.length > 0 && (
            <CategoriaRow>
              {categorias.map((cat) => (
                <CategoriaPill
                  key={cat.slug}
                  href={`${MF_BASE}/blog/categoria/${cat.slug}`}
                  onClick={(e) => {
                    e.preventDefault();
                    goToCategoria(cat.slug);
                  }}
                >
                  {getCategoriaLabel(cat.slug)} ({cat.count})
                </CategoriaPill>
              ))}
            </CategoriaRow>
          )}
        </BlogHeader>

        {loading && <LoadingWrap>Carregando…</LoadingWrap>}

        {!loading && posts.length === 0 && (
          <EmptyState>
            <h3>Em breve</h3>
            <p>
              Estamos preparando os primeiros artigos. Volte em alguns dias.
            </p>
          </EmptyState>
        )}

        {!loading && featured && (
          <HeroPost
            href={`${MF_BASE}/blog/${featured.slug}`}
            onClick={(e) => {
              e.preventDefault();
              goToPost(featured.slug);
            }}
          >
            <HeroImageWrap>
              {featured.imagem_capa && (
                <HeroImage
                  src={getBlogImageUrl(featured.imagem_capa)}
                  alt={featured.titulo}
                />
              )}
            </HeroImageWrap>
            <HeroContent>
              <PostCardMeta>
                {featured.categoria && (
                  <span>{getCategoriaLabel(featured.categoria)}</span>
                )}
                {featured.categoria && <span>·</span>}
                <span>{estimateReadingTime(featured.conteudo_md)} min</span>
              </PostCardMeta>
              <HeroPostTitle>{featured.titulo}</HeroPostTitle>
              <HeroPostExcerpt>
                {featured.resumo || featured.subtitulo}
              </HeroPostExcerpt>
              <PostCardMeta style={{ color: '#A0A6B2', marginTop: 0 }}>
                <span>{formatPostDate(featured.published_at)}</span>
              </PostCardMeta>
            </HeroContent>
          </HeroPost>
        )}

        {!loading && rest.length > 0 && (
          <PostGrid>
            {rest.map((post, i) => (
              <BlogCard key={post.id} post={post} index={i} />
            ))}
          </PostGrid>
        )}
      </BlogContainer>

      <Footer />
    </BlogPage>
  );
}
